<template>
  <div v-if="pageshow">
    <div class="mm-row">
      <div class="mm-col">
        <div class="mm-item">
          <label class="mm-label">類別：</label>
          <div>
            <el-radio-group disabled v-model="data.ordertype">
              <el-radio-button label="0">兌換</el-radio-button>
              <el-radio-button label="1">匯款</el-radio-button>
              <el-radio-button label="2">內部記賬</el-radio-button>

            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div class="mm-row">
      <div class="mm-col" style="flex: 0 40%;">
        <div class="mm-item">
          <label class="mm-label">建立部門：</label>
          <div class="mm-item-content">
            <div class="flexbox bumenname">
              {{data.sectorname?data.sectorname:(data.store_shortname+' '+data.storename)}}
            </div>
            <div>
              <!-- <el-link icon="el-icon-circle-plus">共享</el-link> -->
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="mm-row">
      <div class="mm-col" style="flex: 0 80%;">
        <div class="mm-item">
          <label class="mm-label">所屬門店：</label>
          <div class="mm-item-content">
            <div class="flexbox">
              {{data.store_shortname}} {{data.storename}}
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="mm-row">
      <div class="mm-col" style="flex: 0 80%;">
        <div class="mm-item">
          <label class="mm-label">開單員工：</label>
          <div class="mm-item-content">
            <div class="flexbox">
              {{data.username}}<span v-if="data.operator!=''">({{data.operator}})</span>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="mm-row">
      <div class="mm-col" style="flex: 0 80%;">
        <div class="mm-item">
          <label class="mm-label">匯率：</label>
          <div class="mm-item-content">
            <div class="flexbox">
              <template v-if="data.buy.num>1||data.sell.num>1">
                <span>多筆交易不適合</span>
              </template>
              <template v-else>
                <span v-if="data.rate">{{data.rate}}</span>
                <span v-else-if="data.sell.short_name!='HKD'" v-html="data.sell.rate"></span>
                <span v-else-if="data.sell.short_name =='HKD'" v-html="data.buy.rate"></span>
              </template>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="mm-row">
      <div class="mm-col" style="flex: 0 80%;">
        <div class="mm-item mm-phone320">
          <label class="mm-label">總買入：</label>
          <div class="mm-item-content" v-if="data.buy.short_name">
            <div class="flexbox">
              <div class="mr10">
                <!-- <img style="width: 30px; height: 30px;" :src="hkdicon"> -->
                <img style="width: 30px; height: 30px;" :src="data.buy.thumb!=''?apiurl+data.buy.thumb:''" />
              </div>
              <div>
                <span class="mr10">{{data.buy.short_name+' '+data.buy.name}} </span>
                <span class="mr10">{{tomoney(data.buy.sum_money||0)}}</span>
                <span class="mr10" v-if="data.buy.short_name!='HKD'">折合 ({{hkdcurrency}} {{tomoney(data.buy.sum_hkd)}})</span>
                <span>(共{{data.buy.num}}筆<span v-if="data.sxf">，含手續費</span>)</span>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <div class="mm-row">
      <div class="mm-col" style="flex: 0 80%;">
        <div class="mm-item mm-phone320">
          <label class="mm-label">總賣出：</label>
          <div class="mm-item-content" v-if="data.sell.short_name">
            <div class="flexbox">
              <div style="margin-right: 10px;">
                <!-- <img style="width: 30px; height: 30px;" :src="hkdicon"> -->
                <img style="width: 30px; height: 30px;" :src="data.sell.thumb!=''?apiurl+data.sell.thumb:''" />
              </div>
              <div>
                <span class="mr10">{{data.sell.short_name+' '+data.sell.name}} </span>
                <span class="mr10">{{tomoney(data.sell.sum_money||0)}}</span>
                <span class="mr10" v-if="data.sell.short_name!='HKD'">折合 ({{hkdcurrency}} {{tomoney(data.sell.sum_hkd)}})</span>
                <span>(共{{data.sell.num}}筆)</span>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <div v-if="data.sxf" class="mm-row">
      <div class="mm-col" style="flex: 0 80%;">
        <div class="mm-item">
          <label class="mm-label">手續費：</label>
          <div class="mm-item-content">
            <div class="flexbox">
              <div style="margin-right: 10px;">
                <img style="width: 30px; height: 30px;" :src="data.sxf.thumb!=''?apiurl+data.sxf.thumb:''" />
              </div>
              <div>
                <span class="mr10">{{data.sxf.name}}</span>
                <span class="mr10">{{data.sxf.short_name}}</span>
                <span class="mr10">{{tomoney(data.sxf.sum_money)}}</span>
                <span class="mr10" v-if="data.sxf.short_name!='HKD'">折合 (HKD 港幣 {{tomoney(data.sxf.sum_hkd)}})</span>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="mm-row">
      <div class="mm-col" style="flex: 0 40%;">
        <div class="mm-item">
          <label class="mm-label">狀態：</label>
          <div class="mm-item-content">
            <div class="flexbox">
              <span style="color: #409EFF;" v-if="data.status == 0">準備中 Pending</span>
              <span style="color:#c810d4;" v-if="data.status == 1">已審核 Approved</span>
              <span style="color:#d8d108;" v-if="data.status == 2">處理中 Processing</span>
              <span style="color: #179A16;" v-if="data.status == 3">已完成 Successful</span>
              <span style="color: #e95801;" v-if="data.status == 4">失敗 Fail</span>
              <span style="color: #cf1d06;" v-if="data.status == 5">已刪除 Deleted</span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="mm-row">
      <div class="mm-col" style="flex: 0 80%;">
        <div class="mm-item">
          <label class="mm-label">日期：</label>
          <div class="mm-item-content">
            <div class="flexbox">
              {{data.date}}
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="mm-row">
      <div class="mm-col">
        <div class="mm-item">
          <label class="mm-label">備註：</label>
          <div class="mm-item-content">
            <div class="flexbox">
              <el-input disabled="" type="textarea" :rows="2" v-model="data.remarks"></el-input>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  props: ['order_id'],
  data () {
    return {
      pageshow: false,
      data: {},
    };
  },
  computed: {
    hkdicon () {
      return require('@/assets/0.png');
    },
    hkdcurrency () {
      return 'HKD 港幣';
    }
  },
  methods: {
    getdata () {
      // console.log(this.order_id);
      this.post('/api/order/orderinfo', {
        order_id: this.order_id
      }).then((res) => {
        if (res) {
          this.data = res;
          this.pageshow = true;
        }
      }).catch((err) => {

        console.log(err)
      })
    }
  },
  created () {
    this.getdata();
  }
};
</script>

<style scoped>
.mr10 {
  margin-right: 10px;
}
.mm-row {
  padding: 10px 0;
}

.mm-label {
  width: 180px;
}

.mm-item-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}

.flexbox {
  display: flex;
  height: 40px;
  align-items: center;
}
@media screen and (max-width: 320px) {
  .orderbox {
    display: block;
  }
  .order-right {
    margin-top: 10px;
  }
  .mm-tabs-content {
    padding: 10px 5px;
  }
  .mm-phone320 {
    display: block;
  }
}
</style>
